import React from 'react';
import ReactDOM from 'react-dom';
import './shared/fonts.css';
import './shared/tokens.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';

// ReactDOM.render(
//     <App />
//   document.getElementById('root')
// );
<meta name="viewport" content="width=device-width,initial-scale=1"/>

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
